import { MachineGuards } from 'common/bento/types/MachineConfig';

import { VerificationStatus } from '../../Verification/lib/steps/types';
import getDraftStatutesDocument from '../libs/getDraftStatutesDocument';
import getDraftStatutesStatus from '../libs/getDraftStatutesModuleStatus';
import { Model } from './model';

export enum Guard {
  HasDraftStatutes = 'hasDraftStatutes',
  IsDraftStatutesInvalid = 'isDraftStatutesInvalid',
}

const guards: MachineGuards<Model, Guard> = {
  hasDraftStatutes: ({ getModuleData }) => {
    const { company } = getModuleData().data.viewer;
    const draftStatutes = getDraftStatutesDocument(company);

    return Boolean(draftStatutes);
  },
  isDraftStatutesInvalid: ({ getModuleData }) => {
    const { company } = getModuleData().data.viewer;

    const status = getDraftStatutesStatus({
      isCapitalDeposit: true,
      isCompanyCreationSASU: false,
      isMainApplicant: true,
      kybDocuments: company.kybDocuments,
    });

    return status === VerificationStatus.Invalid;
  },
};

export default guards;
